import { Box, Button, IconButton, Modal, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Scrollbar from './Scrollbar';

export default function AppModal({ open, onClose, header, maxWidth, footer, children }) {
  const { t } = useTranslation();
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          maxWidth,
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 24,
          p: 2,
          outline: 'none',
          maxHeight: '100vh',
        }}
      >
        <Stack direction="column">
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
            <div>{header}</div>
            <IconButton size="small" onClick={onClose} sx={{ fontSize: 14, width: 30, height: 30 }}>
              X
            </IconButton>
          </Stack>
          <div
            style={{
              maxHeight: 'calc(100vh - 230px)',
              overflow: 'auto',
            }}
          >
            <Scrollbar sx={{ mt: 1.5 }}>{children}</Scrollbar>
          </div>
          {footer && <div>{footer}</div>}
        </Stack>
      </Box>
    </Modal>
  );
}
